import { makeStyles } from '@material-ui/core/styles';
import { color } from 'styles/color.styles';

export const useProductImage = makeStyles(theme => ({
  tile: {
    '& > div': {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  },
  imageContainer: {
    background: 'none',
    flex: 2,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    display: 'flex',
    borderRadius: 8
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  },
  imageTitle: {
    background: theme.palette.secondary.light,
    flex: 1,
    '& > div': {
      marginLeft: '10px',
      marginRight: '10px',
      marginBottom: '5px'
    },
    '& > div > div:first-child': {
      color: theme.palette.text.primary,
      fontSize: '14px',
      fontWeight: '500'
    },
    '& > div > div': {
      color: theme.palette.primary.main,
      fontSize: '14px'
    }
  },
  imageTitleTop: {
    '& > div': {
      marginLeft: '10px',
      marginRight: '5px',
      marginBottom: '0px'
    }
  },
  actionIconContainer: {
    display: 'flex',
    '& .MuiSvgIcon-root': {
      fontSize: '1.2rem',
      color: theme.palette.primary.main
    }
  },
  item: {
    listStyleType: 'none',
    '& > div': {
      border: 'none'
    },
    '& > div > div': {
      background: 'none !important'
    }
  }
}));
